export default __webpack_public_path__ + "static/media/ca758cdb2e888b0f.87c3f3f9141bc687c229299004184801.svg";